interface RenderParams {
  sitekey: string;
  callback?: (token: string, preClearanceObtained: boolean) => void;
  'error-callback'?: (errorCode: string) => void;
  'before-interactive-callback'?: VoidFunction;
  'after-interactive-callback'?: VoidFunction;
  language?: string;
  appearance?: string;
  theme?: string;
  retry?: string;
}

interface TurnstileSDK {
  render: (container: string | HTMLElement, params: RenderParams) => void;
  remove: (container: string | HTMLElement) => void;
}

declare global {
  interface Window {
    turnstile?: TurnstileSDK;
  }
}

const SDK_SCRIPT_ID = 'cf-tunstile-script';
type SDKScript = HTMLScriptElement & { __sdk_promise__: Promise<TurnstileSDK> };

export function getTurnstileSDK() {
  const existingScript = document.getElementById(
    SDK_SCRIPT_ID,
  ) as SDKScript | null;
  if (existingScript) {
    return existingScript.__sdk_promise__;
  }

  const script = document.createElement('script') as SDKScript;
  script.id = SDK_SCRIPT_ID;
  script.async = true;
  script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
  script.__sdk_promise__ = new Promise((resolve, reject) => {
    script.onload = () => {
      if (window.turnstile) {
        resolve(window.turnstile);
      } else {
        reject(new Error('[CF TURNSTILE] invalid SDK'));
      }
    };

    script.onerror = () =>
      reject(new Error('[CF TURNSTILE] failed to load SDK'));

    document.body.appendChild(script);
  });

  return script.__sdk_promise__;
}
